import React, { useEffect, useState } from 'react';
// import { checkPrivs } from 'Utils/checkPrivs';

import { getRegions, getAOs } from 'API';

// order is important here
// search will stop at the first entry that INCLUDES the 'path' string
// therefore, admin must be after admin/product/search, etc.
// this is necessary to deal with paths that include a paramater, like '/product-detail/:pid'
const pathsToTitles = [
  { path: 'aos', title: 'AOs' },
  { path: 'ao', title: 'AO' },
  { path: 'apft', title: 'APFT' },
  { path: 'bd', title: 'BD' },
  { path: 'pax', title: 'PAX' },
  { path: 'regions', title: 'Regions' },
  { path: 'region', title: 'Region' },
];

export default function Header({ user }) {
  const [regions, setRegions] = useState([]);
  const [aos, setAos] = useState([]);

  // const title = pathsToTitles.find(p => window.location.pathname.includes(p.path));

  const clickRegion = (evt) => {
    if (evt.target.value === 'all') {
      window.location.replace('/app/regions');
    } else {
      window.location.replace(`/app/region?region=${evt.target.value}`);
    }
  }

  const clickAo = (evt) => {
    if (evt.target.value === 'all') {
      window.location.replace('/app/aos');
    } else {
      window.location.replace(`/app/ao?ao=${evt.target.value}`);
    }
  }

  useEffect(() => {
    (async () => {
      const [regions, aos] = await Promise.all([
        getRegions(),
        getAOs(),
      ]);

      setRegions(regions);
      setAos(aos);
    })();
  }, []);

  return (
    <div id="top-bar" className="flex-row space-between">
      <div className="cell cell-auto">
        <a
          href="/app/pax"
          className="logo-header"
        />
      </div>

      <div className="cell cell-30"></div>

      <div className="cell cell-auto">
        <select name="regions" id="regions" onChange={clickRegion}>
          <option value="" style={{ display: 'none' }}>Region</option>
          <option value="all">All</option>
          {
            regions.filter(region => region.name !== null).map(region => <option value={region.name} key={region.region}>{region.name}</option>)
          }
        </select>
      </div>

      <div className="cell cell-auto">
        <select name="aos" id="aos" onChange={clickAo}>
          <option value="" style={{ display: 'none' }}>AO</option>
          <option value="all">All</option>
          {
            aos.map(ao => <option value={ao.aoId} key={ao.aoId}>{ao.name}</option>)
          }
        </select>
      </div>

      <div className="cell cell-auto">
        <a href="/app/apft">APFT</a>
      </div>

      <div className="cell cell-auto">
        <a href="/app/pax">PAX</a>
      </div>

      {/* <h2 className="page-title">
        {title ? title.title : 'PAX Viewer'}
      </h2> */}

      <div className="cell cell-30" style={{ float: 'right', paddingTop: '15px', paddingRight: '30px' }}>
        {
          Object.keys(user).length !== 0
            ? (
              <span style={{ float: 'right' }}>
                <a className='no-padding' style={{ float: 'right' }} href={`/app/pax?pax=${user.paxId}`}>{user.name}</a>
                <br />
                <a style={{ float: 'right' }} href="/auth/logout">Log Out</a>
              </span>
            ) : <a style={{ float: 'right' }} href="/">Log In</a>
        }
      </div>
    </div>
  );
}
